// @flow
/* eslint react/require-default-props: 0 */

import React, { Component } from 'react';
import type { ComponentType } from 'react';

type State = {
  collapsed?: boolean,
};

type InjectedProps = {|
  onCollapse: Function | void,
|};

const withCollapse = <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<$Exact<Props>, InjectedProps>> => (
    class WrapperComponent extends Component<$Exact<Props>, State> {
      constructor() {
        super();

        this.state = {
          collapsed: true,
        };
      }

      handleChange = () => {
        this.setState(prevState => ({
          collapsed: !prevState.collapsed,
        }));
      }

      render() {
        const { collapsed } = this.state;
        return (
          <WrappedComponent
            collapsed={collapsed}
            onCollapse={this.handleChange}
            {...this.props}
          />
        );
      }
    }
  );

export default withCollapse;
